import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

const StyledActionButton = styled(Button)(() => ({
    padding: "7px 16px",
}));

const GenerateImageEditorButtons = (props) => {
    const { handleGenerateClick, handleCloseModal, shouldDisableButtons } = props;
    return (
        <React.Fragment>
            <StyledActionButton onClick={handleCloseModal} variant="outlined">
                Cancel
            </StyledActionButton>
            <StyledActionButton
                onClick={handleGenerateClick}
                variant="contained"
                color="primary"
                disabled={shouldDisableButtons}
            >
                Generate
            </StyledActionButton>
        </React.Fragment>
    );
};

export default GenerateImageEditorButtons;
